import { createElement } from "react";
import * as react from "react";
import { createObj } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { ofArray } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { printf, toText } from "./fable_modules/fable-library-js.4.17.0/String.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.17.0/Seq.js";

export function smallIconButton(className, onClick) {
    let elems;
    return createElement("button", createObj(ofArray([["style", {
        cursor: "pointer",
        margin: 0,
        marginRight: 4,
        padding: 0,
        border: "none",
        background: "none",
        height: 18,
        width: 18,
    }], ["onClick", onClick], (elems = [createElement("i", {
        className: className,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function groupButtonLeft(isActive, onClick, children) {
    return createElement("button", {
        className: isActive ? "grouped-button-left grouped-button-active" : "grouped-button-left",
        onClick: onClick,
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function groupButtonCenter(isActive, onClick, children) {
    return createElement("button", {
        className: isActive ? "grouped-button-center grouped-button-active" : "grouped-button-center",
        onClick: onClick,
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function groupButtonRight(isActive, onClick, children) {
    return createElement("button", {
        className: isActive ? "grouped-button-right grouped-button-active" : "grouped-button-right",
        onClick: onClick,
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function assetListHolder(children) {
    return createElement("div", {
        style: {
            marginBottom: 15,
            marginRight: 15,
            maxWidth: 300,
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function assetListEntry(ticker, name, link) {
    let elems_2, elems, elems_1;
    return createElement("div", createObj(ofArray([["className", "preview-listing-holder"], (elems_2 = [createElement("div", createObj(ofArray([["className", "preview-listing-name"], (elems = [createElement("a", {
        href: link,
        children: name,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "preview-listing-ticker"], (elems_1 = [createElement("a", {
        href: link,
        children: ticker,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function Image_avatar(src, size) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "user-avatar"], ["style", {
        width: size + "px",
        height: size + "px",
    }], (elems = [createElement("img", {
        alt: "User image",
        src: src,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Image_iconAvatar(size, icon) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "user-avatar"], ["style", {
        width: size + "px",
        height: size + "px",
    }], (elems = [createElement("i", {
        className: icon,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export function Image_userCircle(userId, size, isLarge, randHash) {
    let arg_1, arg_2;
    return Image_avatar((arg_1 = (isLarge ? "normal" : "small"), (arg_2 = ((randHash != null) ? (`&r=${randHash}`) : ""), toText(printf("/api/user/image/%i?size=%s%s"))(userId)(arg_1)(arg_2))), size);
}

export function Image_circledImage(size, imgUrl) {
    return Image_avatar(imgUrl, size);
}

export function User_usernameText(x, postRemoved) {
    if (!postRemoved) {
        const xs_3 = toList(delay(() => append(singleton(createElement("a", {
            href: `/user/${x.Username}`,
            children: createElement("span", {
                style: {
                    color: "var(--bg-dark)",
                    fontWeight: 500,
                },
                children: x.Username,
            }),
        })), delay(() => (x.Official ? singleton(createElement("span", {
            style: {
                marginLeft: 5,
                color: "var(--text-main)",
                fontSize: 0.8 + "rem",
            },
            className: "fas fa-shield-alt",
        })) : empty())))));
        return react.createElement(react.Fragment, {}, ...xs_3);
    }
    else {
        return createElement("span", {
            children: x.Username,
        });
    }
}

